// extracted by mini-css-extract-plugin
module.exports = {"statisticCard":"Statistic_statisticCard__3UJFq","measure":"Statistic_measure__2Z0Rd","measurement":"Statistic_measurement__3_cjJ"};